var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56579 0.914297C6.9335 0.117111 8.0665 0.117109 8.43421 0.914294L9.87115 4.02958C10.021 4.35449 10.3289 4.57819 10.6842 4.62032L14.0911 5.02426C14.9629 5.12762 15.313 6.20517 14.6685 6.80122L12.1497 9.13052C11.887 9.37344 11.7694 9.73541 11.8391 10.0863L12.5077 13.4513C12.6788 14.3123 11.7622 14.9783 10.9961 14.5495L8.00251 12.8738C7.69029 12.699 7.3097 12.699 6.99749 12.8738L4.00386 14.5495C3.2378 14.9783 2.32119 14.3123 2.49228 13.4513L3.16089 10.0863C3.23062 9.73541 3.11301 9.37344 2.85032 9.13052L0.331546 6.80122C-0.312995 6.20517 0.0371201 5.12762 0.908916 5.02426L4.31577 4.62032C4.67108 4.57819 4.97899 4.35449 5.12885 4.02959L6.56579 0.914297Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.42848c1bcbfd618e65b4b3a1c7a16cf2.svg";
export { ForwardRef as ReactComponent };